export const COVERAGE_MAP_AREAS = [
  {
    coords: '163, 70, 223, 96',
    region: 'seattle',
    shape: 'rect',
  },
  {
    coords: '272, 216, 377, 242',
    region: 'salt-lake-city',
    shape: 'rect',
  },
  {
    coords: '266.438, 302, 332.0867, 324.5405',
    region: 'las-vegas',
    shape: 'rect',
  },
  {
    coords: '295.135, 349.033, 351.7836, 371.5735',
    region: 'phoenix',
    shape: 'rect',
  },
  {
    coords: '420, 239, 482, 265',
    region: 'denver',
    shape: 'rect',
  },
  {
    coords: '573, 383, 696, 409',
    region: 'dallas',
    shape: 'rect',
  },
  {
    coords: '543, 417, 600, 443',
    region: 'austin',
    shape: 'rect',
  },
  {
    coords: '597, 465, 667, 491',
    region: 'houston',
    shape: 'rect',
  },
  {
    coords: '746, 358, 809, 384',
    region: 'atlanta',
    shape: 'rect',
  },
  {
    coords: '231, 104, 302, 130',
    region: 'spokane',
    shape: 'rect',
  },
  {
    coords: '721, 435, 812, 461',
    region: 'tallahassee',
    shape: 'rect',
  },
  {
    coords: '815, 416, 910, 442',
    region: 'jacksonville',
    shape: 'rect',
  },
  {
    coords: '800, 465, 859, 491',
    region: 'tampa',
    shape: 'rect',
  },
  {
    coords: '860, 459, 928, 485',
    region: 'orlando',
    shape: 'rect',
  },
  {
    coords: '863, 502, 918, 528',
    region: 'miami',
    shape: 'rect',
  },
  {
    coords: '872, 203, 970, 229',
    region: 'philadelphia',
    shape: 'rect',
  },
  {
    coords: '684, 189, 752, 215',
    region: 'chicago',
    shape: 'rect',
  },
  {
    coords: '476, 447, 571, 473',
    region: 'san-antonio',
    shape: 'rect',
  },
  {
    coords: '787, 295, 863, 321',
    region: 'charlotte',
    shape: 'rect',
  },
  {
    coords: '872, 292, 963, 318',
    region: 'greensboro',
    shape: 'rect',
  },
  {
    coords: '849, 323, 974, 349',
    region: 'raleigh-durham',
    shape: 'rect',
  },
  {
    coords: '852, 349, 938, 375',
    region: 'charleston',
    shape: 'rect',
  },
  {
    coords: '824, 387, 903, 413',
    region: 'savannah',
    shape: 'rect',
  },
  {
    coords: '170, 269, 268.6487, 291.5405',
    region: 'san-luis-obispo',
    shape: 'rect',
  },
  {
    coords: '101, 294, 189.6487, 316.5405',
    region: 'santa-barbara',
    shape: 'rect',
  },
  {
    coords: '150, 319, 204.6486, 341.5405',
    region: 'ventura',
    shape: 'rect',
  },
  {
    coords: '138, 344, 215.6487, 366.5405',
    region: 'los-angeles',
    shape: 'rect',
  },
  {
    coords: '222, 338, 284.6486, 360.5405',
    region: 'riverside',
    shape: 'rect',
  },
  {
    coords: '164, 369, 257.6487, 391.5405',
    region: 'orange-county',
    shape: 'rect',
  },
  {
    coords: '204, 394, 271.6487, 416.5405',
    region: 'san-diego',
    shape: 'rect',
  },
  {
    coords: '119.107, 204.569, 196.7557, 227.1095',
    region: 'sacramento',
    shape: 'rect',
  },
  {
    coords: '107, 244, 183.6487, 266.5405',
    region: 'bay-area',
    shape: 'rect',
  },
  {
    coords: '307, 414, 357.6486, 436.5405',
    region: 'tucson',
    shape: 'rect',
  },
  {
    coords: '307, 414, 357.6486, 436.5405',
    region: 'tucson',
    shape: 'rect',
  },
  {
    coords: '669.479, 337.679, 732.1276, 360.2195',
    region: 'memphis',
    shape: 'rect',
  },
  {
    coords: '720.973, 312.795, 782.6216, 335.3355',
    region: 'nashville',
    shape: 'rect',
  },
  {
    coords: '765.59, 331.27, 827.2386, 353.8105',
    region: 'knoxville',
    shape: 'rect',
  },
  {
    coords: '900.04, 228.111, 1002.69, 250.652',
    region: 'metro-dc-north',
    shape: 'rect',
  },
  {
    coords: '810, 191.586, 879.649, 214.126',
    region: 'pittsburgh',
    shape: 'rect',
  },
  {
    coords: '889, 112, 933.649, 132.541',
    region: 'buffalo',
    shape: 'rect',
  },
  {
    coords: '860.199, 138.028, 902.848, 158.569',
    region: 'albany',
    shape: 'rect',
  },
  {
    coords: '843.165, 160.967, 894.814, 181.508',
    region: 'syracuse',
    shape: 'rect',
  },
  {
    coords: '891.001, 158.818, 947.65, 179.359',
    region: 'rochester',
    shape: 'rect',
  },
  {
    coords: '911.001, 128.818, 967.65, 149.359',
    region: 'worcester',
    shape: 'rect',
  },
  {
    coords: '963.838, 157.488, 1027.49, 178.028',
    region: 'long-island',
    shape: 'rect',
  },
  {
    coords: '900.04, 179.962, 987.689, 202.503',
    region: 'new-york-city',
    shape: 'rect',
  },
  {
    coords: '762.57, 212.328, 815.891, 230.929',
    region: 'cleveland',
    shape: 'rect',
  },
  {
    coords: '757.385, 234.587, 806.614, 251.278',
    region: 'columbus',
    shape: 'rect',
  },
  {
    coords: '768.765, 257.639, 813, 272.502',
    region: 'cincinnati',
    shape: 'rect',
  },
  {
    coords: '966, 137, 1027, 163',
    region: 'boston',
    shape: 'rect',
  },
  {
    coords: '843.78, 265, 892.429, 283.541',
    region: 'richmond',
    shape: 'rect',
  },
  {
    coords: '835.875, 280.994, 874.524, 299.534',
    region: 'norfolk',
    shape: 'rect',
  },
  {
    coords: '898.205, 266.909, 966.854, 285.45',
    region: 'metro-dc-south',
    shape: 'rect',
  },
  {
    coords: '882.178, 247.078, 951.826, 265.619',
    region: 'washington-dc',
    shape: 'rect',
  },
];
